import { format } from 'owa-localize';

import { GetTasksResponse } from './GetTasksServiceResponse';
import {
    TODO_API_GET_TASKS_IN_FOLDER_FORMAT,
    TODO_API_DEFAULT_FOLDER,
    TODO_API_GET_TASKS_IN_DEFAULT_FOLDER_URL,
} from './constants';
import { makeTodoGetRequest } from './makeTodoGetRequest';

/**
 * Makes the Get tasks call to the server to get task items for the specified folder
 * or the default tasks folder if not specified.
 * @param {string} folderId optional folder id of requested task folder
 * @returns promise of GetTasksServiceResponse
 */
export default async function getTasksService(folderId?: string): Promise<GetTasksResponse> {
    const folderIdToUse = folderId ? folderId : TODO_API_DEFAULT_FOLDER;
    const actionName = 'GET_TASKS_IN_FOLDER';
    const url = format(TODO_API_GET_TASKS_IN_FOLDER_FORMAT, folderIdToUse);
    let taskResponse = await makeTodoGetRequest(url, actionName);
    if (taskResponse.errorResponse) {
        /** TODO VSO 38608: this retry logic is needed when the user is a notes user, because of recent regression */
        const retryActionName = 'GET_TASKS_IN_FOLDER_RETRY';
        const retryURL = format(TODO_API_GET_TASKS_IN_DEFAULT_FOLDER_URL, folderIdToUse);
        taskResponse = await makeTodoGetRequest(retryURL, retryActionName);
    }
    return taskResponse;
}
